import { render, staticRenderFns } from "./EmailComponent.vue?vue&type=template&id=6eb32e86&scoped=true"
import script from "./EmailComponent.vue?vue&type=script&lang=js"
export * from "./EmailComponent.vue?vue&type=script&lang=js"
import style0 from "./EmailComponent.vue?vue&type=style&index=0&id=6eb32e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb32e86",
  null
  
)

export default component.exports